
<nav-bar></nav-bar>
<div class="page-coverage scroller column">
  <w-page-section *ngFor="let obj of continents" title="{{ ('designation.' + obj.continentCC) | translate}}" [collapsed]="false">
    <f-facet name="content">
      <ul class="flex flexWrap">
        <li class="flex" *ngFor="let country of obj.countries" [class.selected]="country.cc===ms.officeCC">
          <div class="left">
            <div class="titleAnExplore flex">
              <h4>{{ ('office.'+country.cc) | translate }} ({{ ('designation.'+country.cc) | translate | uppercase }})&nbsp;</h4>
            </div>
            <div><span>{{'page_coverage.number_of_records' | translate}}</span><span>{{country.records | number}}</span></div>
            <div *ngIf="country.earliest"><span>{{'page_coverage.coverage_from' | translate}}</span><span>{{country.earliest}}</span></div>
            <div *ngIf="country.updated"><span>{{'page_coverage.coverage_to' | translate}}</span><span>{{country.updated}}</span></div>
          </div>
          <div class="right flex column">
            <div class="logo" [ngStyle]="{ 'background-image' : 'url(/assets/images/offices/' + country.cc + '.png)' }"></div>
            <div class="explore flex center-h"><a class="centered" *ngIf="country.cc === ms.officeCC; else selectAndExplore" (click)="doReset()">{{ 'general_words.unselect' | translate }}</a>
              <ng-template #selectAndExplore><a class="centered" (click)="doSearch(country.cc)">{{ 'page_coverage.select_and_explore' | translate }}</a></ng-template>
            </div>
          </div>
        </li>
      </ul>
    </f-facet>
  </w-page-section>
</div>
